module.exports = __webpack_public_path__ + "static/media/green_cloud_burst.133e0064.png";